"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gardone-riviera": {
    "29cefdc1": [{
      "hkey": "ff76f8f3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "fasano-sopra": [{
      "hkey": "ff76f8f3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gardone-riviera"
    }],
    "fd648252": [{
      "hkey": "ff76f8f3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "fasano-sotto": [{
      "hkey": "ff76f8f3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gardone-riviera"
    }],
    "6e251051": [{
      "hkey": "ff76f8f3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "gardone-sopra": [{
      "hkey": "ff76f8f3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gardone-riviera"
    }],
    "0405e75a": [{
      "hkey": "ff76f8f3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "gardone-sotto": [{
      "hkey": "ff76f8f3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gardone-riviera"
    }],
    "cb50806a": [{
      "hkey": "ff76f8f3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "morgnaga": [{
      "hkey": "ff76f8f3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gardone-riviera"
    }],
    "5550f7c6": [{
      "hkey": "3a973490",
      "slug": "val-di-sur-san-michele",
      "name": "Val di Sur-San Michele",
      "primary": true,
      "skipSearch": false
    }],
    "san-michele": [{
      "hkey": "3a973490",
      "slug": "val-di-sur-san-michele",
      "name": "Val di Sur-San Michele",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;